module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.promotionData,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Competition",
      "class-name": "promotion-topic-name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entries",
      "label": "Entries",
      "width": "75"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uniques",
      "label": "Uniques",
      "width": "75"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72a06dd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/programmingDashboard/PromotionsTable.vue
// module id = 3338
// module chunks = 3